import { render, staticRenderFns } from "./taskRecord.vue?vue&type=template&id=23bbee2f&scoped=true"
import script from "./taskRecord.vue?vue&type=script&lang=js"
export * from "./taskRecord.vue?vue&type=script&lang=js"
import style0 from "./taskRecord.vue?vue&type=style&index=0&id=23bbee2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbee2f",
  null
  
)

export default component.exports